import { ValidationService, type IValidationService } from '@stepform';

export class MentalHealthValidationService extends ValidationService implements IValidationService {}
